/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Locale_SwitchInputs */

const en_common_locale_switch = /** @type {(inputs: Common_Locale_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch language`)
};

const zh_common_locale_switch = /** @type {(inputs: Common_Locale_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换语言`)
};

/**
* | output |
* | --- |
* | "Switch language" |
*
* @param {Common_Locale_SwitchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_locale_switch = /** @type {((inputs?: Common_Locale_SwitchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Locale_SwitchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_locale_switch(inputs)
	return zh_common_locale_switch(inputs)
});
export { common_locale_switch as "common.locale.switch" }